import React from 'react'
import Logo from '../img/logo.jpg'
import AnchorLink from 'react-anchor-link-smooth-scroll'




export class FooterInner extends React.PureComponent {

    render() {
        return (
            <div>
                <div className="d-flex justify-content-around align-items-center">
                    <div>
                        <img className="logo" src={Logo} alt="Logo" />
                    </div>
                <nav id="FooterNav">
                    <ul className="nav">
                        <li className="nav-item"><AnchorLink  className="nav-link active text-white" href="#about">Over</AnchorLink ></li>
                        <li className="nav-item"><AnchorLink  className="nav-link text-white" href="#schedule">Schema</AnchorLink ></li>
                        <li className="nav-item"><AnchorLink  className="nav-link text-white" href="#media">Media</AnchorLink ></li>
                        <li className="nav-item"><AnchorLink  className="nav-link text-white" href="#location">Locatie</AnchorLink ></li>
                        <li className="nav-item"><AnchorLink  className="nav-link text-white" href='#contact'>Contact</AnchorLink></li>
                    </ul>
                </nav>
                </div>
                    <div className="d-flex justify-content-center mt-5">
                        <p className="text-center text-white">Complex is een Braziliaanse Jiu Jitsu club opgericht in 2018 met als doel de gevechtskunst die onze levens zo positief beïnvloed heeft te verspreiden.</p>
                    </div>
                    <div className="d-flex justify-content-center py-3">
                        <span className="text-center text-white">Copyright © {new Date().getFullYear()}, - <a className="text-white" href="https://angeloalfanoc.github.io/iamalfanoangelo/">Alfano Angelo</a>, All rights reserved </span>
                    </div>
                </div>
        )
    }
}
export default React.memo(FooterInner)
